import { useAxios } from '@healthblocks-io/core'
import useSWR from 'swr'

import type { CareProgram } from '../types/care-program.type'

export function useCarePrograms() {
  const axios = useAxios()

  const fetcher = async () => {
    const paymentEnabled = await axios.get<{ enabled: boolean }>('/payment/enabled')
    const { data } = await axios.get<CareProgram[]>('/cms/programs')
    return data.filter((program) =>
      paymentEnabled.data.enabled === true ? true : !program.price || program.price.length === 0,
    )
  }

  return useSWR('care-programs', fetcher, { errorRetryCount: 3 })
}

export function useCareProgramById(id?: string) {
  const axios = useAxios()

  const fetcher = async () => {
    const { data } = await axios.get<CareProgram>(`/cms/programs/${id}`)
    return data
  }

  return useSWR(`care-programs_${id}`, fetcher, { errorRetryCount: 3 })
}
